export class ClearCollectionsLoadingStatus {
    public static readonly type = '[JobsPlacements] Clear collections loading status';
}
